<template>
  <div id="sectordetails">
  <!-- START OF TENDU HEADER TOOLBAR  -->
    <div class="progress" v-if="!sectorDetails.address">
      <md-spinner md-indeterminate :md-size="90" :md-stroke="1.8"></md-spinner>
    </div>

    <md-toolbar class="listBar">
      <md-button @click.native="goBack()" class="md-icon-button">
        <md-icon>arrow_back</md-icon>
      </md-button>

      <h2 class="md-title">{{ sectorDetails.name }}</h2>

      <md-button @click.native="goScan()" class="md-icon-button">
        <md-icon>qr_code</md-icon>
      </md-button>
    </md-toolbar>

    <carousel class="sectorPics"
      :starting-image="2"
      :images="sectorDetails.slideImages"
      :auto-slide-interval="2500"
      :show-progress-bar="false">
    </carousel>
    <!-- <carousel v-if="sectorDetails.name == 'DAV Kletterzentrum Coburg'" class="sectorPics"
      :starting-image="1"
      :images="sectorDetails.slideImages"
      :auto-slide-interval="2500"
      :show-progress-bar="false">
    </carousel>
    <carousel v-else class="sectorPics"
      :starting-image="2"
      :images="sectorPhotos"
      :auto-slide-interval="2500"
      :show-progress-bar="false">
    </carousel> -->

    <md-list>
      <div style="margin:auto;">
        <img :src="sectorDetails.imageUrl" align="middle" width="288" height="123" alt="Logo">
      </div>

      <md-list-item class="md-inset md-triple-line">
        <div class="md-list-text-container">
          <span class="md-caption">{{ sectorDetails.openingHours }}</span>
          <span class="md-caption">Schwierigkeit {{ sectorStats.gradeRange.minGrade }} bis {{ sectorStats.gradeRange.maxGrade }}</span>
          <span class="md-caption">{{ sectorStats.noOfRoutes }} Routen</span><br>
        </div>
      </md-list-item>

      <md-divider></md-divider>
        <div class="UIAAstyle md-title">UIAA</div>
        <span id="chart">
          <div id="responsive-chart">
            <apexchart v-if="resetting" class="apexBar" width="100%" height="220" type="bar" :options="sectorBarOptions" :series="sectorSeries"></apexchart>
          </div>
        </span>
      <md-divider style="margin-top:-15px;"></md-divider>

      <md-list-item class="md-inset" @click="sendSectorLink()">
        <span style="color:#C51162; font-size:16px;" v-if="sectorId">Routenliste</span>
      </md-list-item>

      <md-divider class="md-inset"></md-divider>

      <md-list-item>
        <md-avatar><md-icon>place</md-icon></md-avatar>
          <div class="md-list-text-container">
            <p class="md-body-1">{{ sectorDetails.address }}</p>
          </div>
      </md-list-item>
      <md-divider class="md-inset"></md-divider>

      <md-list-item>
        <md-avatar><md-icon>link</md-icon></md-avatar>
            <p class="md-subheading">{{ sectorDetails.url }}</p>
      </md-list-item>

      <md-divider class="md-inset"></md-divider>

      <md-list-item class="md-inset">
          <p class="md-body-1">{{ sectorDetails.description }}</p>
      </md-list-item>

    </md-list>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
import Carousel from './Sectors/Carousel.vue'

export default {
  name: 'sectordetails',
  components: {
    Carousel
  },

  data () {
    return {
      resetting: true,
      // barOptions and series: in vuex store
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.resetting = true
    })
  },

  beforeRouteLeave (to, from, next) {
    next()
      this.resetting = false
  },

  created () {
    if (!this.sectorId) {
      window.location.href = '/'
    }
    console.log('sector', this.sectorDetails)
  },

  computed: {
    ...mapState([
      'validUser',
      'sectorDetails',
      'sectorStats',
      'sectorSeries',
      'sectorPhotos',
      'davPhotos',
      'pageLoading',
      'storeList',
      'isSidebar',
      'changeSector',
      'fiterSet',
      'sectorBarOptions',
    ]),

    sectorId () {
      return this.$store.state.sectorDetails.id
    },

    maxBar () {
      return this.$store.state.sectorBarOptions.yaxis.max
    },
  },

  methods: {
    ...mapMutations([
      'changeMaxBar',
      'changePageLoading',
      'forceKeyrender',
    ]),

    sendSectorLink: function () {
      if ((this.changeSector === this.sectorDetails.name) && (this.storeList.length > 0)) {
        // console.log('the routelist first section is already loaded')
      } else {
        this.changePageLoading(true)
        this.forceKeyrender()
        this.$store.dispatch('getList', this.sectorDetails.links.routes)
      }

      var sectorId = this.sectorId
      this.$router.push({ name: 'routelist', params: { sectorId } })
    },

    goScan () {
      this.$router.push('/Scan')
    },

    goBack () {
      this.$router.push('/')
    },
  }
}

</script>

<style scope>

  .pic {
    min-height:40vh;
    background-size:cover;
    background-position-y: 30%;
    background-repeat:no-repeat;
  }

  #chart {
    opacity: 0.9;
  }

  .apexBar {
    padding-left:50px;
    padding-right:8px;
    max-width: 720px;
    margin-top:-70px;
    margin-left:auto;
    margin-right:auto;
  }

  p {
    font-weight:lighter;
  }

  ul, li {
    list-style-type: none;
    padding: 0;
  }

  .md-boards .md-board {
    padding: 0px !important;
  }

  .md-boards-navigation {
    margin-top:-40px;
  }

  .md-board-header-container {
    color:#ffffff;
    opacity:0.7;
  }

  line[y1="0"].apexcharts-gridline {
    display:none !important;
  }

  .sectorPics {
    margin-top:64px;
    width:100%;
    min-height: 40vh;
    max-height: 50vh;
    overflow:hidden;
  }

</style>
